import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://owzrzqhbczmhgdawfxlb.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im93enJ6cWhiY3ptaGdkYXdmeGxiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODEwNDg1NTIsImV4cCI6MjA5NjYyNDU1Mn0.X769hTIfHqmt68XcJyzvEHyskuxFae9apy1KSKU82GI';

export const supabase = createClient(supabaseUrl, supabaseKey);
